// src/components/legal/LegalAgreementCheckbox.tsx
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { LRNSY_LEGAL } from "../../legal/legal.constants";

export function LegalAgreementCheckbox({
  checked,
  onChange,
  disabled,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <label className="group flex cursor-pointer items-start gap-3 rounded-2xl border border-white/10 bg-white/[0.04] p-4 text-left transition hover:bg-white/[0.07]">
      <input
        type="checkbox"
        required
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
        className="mt-1 h-5 w-5 flex-shrink-0 accent-amber-300"
      />

      <span className="block">
        <span className="flex items-center gap-2 text-xs font-semibold text-white/80">
          <ShieldCheck size={14} className="text-amber-200" />I agree to LRNSY’s legal and privacy
          terms.
        </span>

        <span className="mt-2 block text-[12px] leading-6 text-white/45">
          By continuing, you agree to the{" "}
          <Link
            to={LRNSY_LEGAL.termsPath}
            target="_blank"
            className="text-white underline decoration-white/25 underline-offset-4 hover:text-amber-100"
          >
            Terms of Service
          </Link>
          , acknowledge the{" "}
          <Link
            to={LRNSY_LEGAL.privacyPath}
            target="_blank"
            className="text-white underline decoration-white/25 underline-offset-4 hover:text-amber-100"
          >
            Privacy Policy
          </Link>
          , and understand that LRNSY uses essential cookies and browser storage for login, private
          links, payments, drafts, security, and emotional experience delivery.
        </span>
      </span>
    </label>
  );
}
